import { render, staticRenderFns } from "./OverviewNFR.vue?vue&type=template&id=31aebdee"
import script from "./OverviewNFR.vue?vue&type=script&lang=js"
export * from "./OverviewNFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports